module.exports = __webpack_public_path__ + "img/card-bg-03.1efb9991.png";